import React from 'react';
import { useFormikContext } from 'formik';
import { PricingInventoryFields } from '..';
import { CardSection } from '../primitives';
import { IVariantInitialValuesProps } from '../../views/Product/types';
import { ProductType } from '@shopify-multiseller/graphql/partner/types';

export interface IProductVariantEditorPricingInventorySectionProps {
    disabled?: boolean;
    productType: ProductType;
    quantity?: number;
}

export const ProductVariantEditorPricingInventorySection: React.FC<IProductVariantEditorPricingInventorySectionProps> = ({
    disabled = false,
    productType,
    quantity,
}) => {
    const { values } = useFormikContext<IVariantInitialValuesProps>();

    // For existing variants the stored quantity is passed in from the variant
    // list; new variants start from zero.
    const currentQuantity = values.variant.isNew ? 0 : quantity || 0;

    return (
        <CardSection>
            <div className="space-y-4">
                {/* Sentence case at section-heading weight, like every other
                    section title in the editor — this was the one 18px
                    Title Case heading left in the product flow. */}
                <h3 className="text-sm font-semibold text-foreground">Pricing &amp; inventory</h3>
                <PricingInventoryFields
                    namePrefix="variant"
                    isDigital={productType === ProductType.Digital}
                    currentQuantity={currentQuantity}
                    disabled={disabled}
                    showCurrentQuantityHint
                />
            </div>
        </CardSection>
    );
};
